<template>
  <div>
    <t-date-range-input v-model="dates" class="ma-0 pa-1" @input="setDates()"> </t-date-range-input>
  </div>
</template>

<script>
export default {
  props: ["value"],
  data() {
    return {
      dates: [],
    };
  },
  methods: {
    setDates() {
      this.$emit("input", this.dates);
      this.$emit("change", this.dates);
    },
  },
  mounted() {
    this.dates = [this.value[0], this.value[1]];
  },
};
</script>

<style scoped></style>
